import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CopyToClipboard as Copy } from 'react-copy-to-clipboard';
import { Button, Icon } from 'nallian-shared-ui/lib/components';

const CopyToClipboard = ({ value }) => {
  const { t } = useTranslation();

  return (
    <Copy text={value}>
      <Button icon size="mini">
        <Icon name="copy" title={t('copyToClipboard')} />
      </Button>
    </Copy>
  );
};

CopyToClipboard.propTypes = {
  value: PropTypes.string.isRequired,
};

export default CopyToClipboard;
